/**
 * Page Specific Actions
 * ---------------------
 * 
 * @type {Object}
 */
SITE.Pages = {

    init: function() {
        "use strict";

        var page = $("body").data('page');
        if  (typeof page !== "undefined") {
            
            page = page.replace('-', '');
            
            if  (typeof SITE.Pages[page] !== "undefined") {
                SITE.Pages[page].init();
            }
        }


        // Set Header Image, if any
        // But don't do it for single post templates
        if (typeof SG_HEADER_IMG !== "undefined" 
                && (!$("body").hasClass("single"))) {
            $("#masthead").css('background-image', "url('" + SG_HEADER_IMG + "')");
            $("#headerWrap").addClass("activated");
        }

        // Full transcript
        if($('.entry-content__transcript').length > 0) {
            $('.entry-content__transcript .btn').click(function() {
                if($('.transcript_text').css('display') == 'none') {
                    $('.transcript_text').slideDown();
                } else {
                    $('.transcript_text').slideUp();
                }
            });
        }
        
    },

    common: {

        init: function() {
            "use strict";
        },

        search: function() {

            "use strict";

            $("#searchToggle").click(function() {

                $(this).parent().toggleClass("open");
                $("#searchCrit").focus();
                return false;

            });

        }

    },

    home: {

        init: function() {
            "use strict";

            //SITE.Pages.home.parallax();
            SITE.Pages.home.visitorCity();

        },

        parallax: function() {
            "use strict";

            var el = $('#prodImg'),
                bot = 0;

            $(window).scroll(function() {
                
                bot = parseInt(el.css('bottom'));

                if (bot > -200) {
                    el.css("bottom", (bot - 1) + 'px');
                }
            });
        },

        visitorCity: function() {
            "use strict";

            if($('p.alternative-hero-def-subtitle').length > 0) {
                var data = {
                    'action': 'visitor_city'
                };

                $.post(window.location.origin + '/wp-admin/admin-ajax.php', data, function(response) {
                    $('#visitorCityName').html(response);
                });
            }
        }
    },

    blog: {

        init: function() {
            "use strict";

            

        },
    },

    resources: {

        CurrentFilters: {
            cat: '',
            tag: ''
        },

        init: function() {
            "use strict";

            
            $(".resource-filter a").click(function() {

                var type = '';
                if ($(this).hasClass('cat'))      type = 'cat';
                else if ($(this).hasClass('tag')) type = 'tag';
                else return false;

                SITE.Pages.resources.CurrentFilters[type] = $(this).data('term');

                $(".resource-filter li." + type).removeClass("active");
                $(this).parent().addClass("active");

                var termName = $(this).data('term-name');
                var termUrl = $(this).data('term-url');

                window.history.pushState('string', termName, termUrl);

                SITE.Pages.resources.filter();

                return false;
            
            });


            // On taxonomy pages trigger anchor click
            if( $( '.resource-filter-preselected' ).length ) {

                var resourceFilterType = $( '.resource-filter-preselected' ).data( 'resource-filter-type' );
                var resourceFilterTermId = $( '.resource-filter-preselected' ).data( 'resource-filter-term-id' );

                $( '.resource-filter ul li.' + resourceFilterType + ' a[data-term="' + resourceFilterTermId + '"]' ).click();

            }
    
        },

        filter: function() {
            "use strict";

            var cat = SITE.Pages.resources.CurrentFilters.cat,
                tag = SITE.Pages.resources.CurrentFilters.tag,
                filter = '',
                results;
            
            $("#ResNotFound").hide();

            if (cat > 0) filter = '[data-cat="' + cat + '"]';
            if (tag > 0) filter += '[data-tag="' + tag + '"]';
            
            if (filter !== '') {

                results = $(".resource-listing li").hide().filter(filter)
                if (results.length > 0) results.fadeIn();
                else {
                    $("#ResNotFound")
                        .find('.cat').text($('.cat[data-term=' + cat + ']').text())
                        .end()
                        .find('.tag').text($('.tag[data-term=' + tag + ']').text())
                        .end()
                        .fadeIn();
                }

            } else {

                $(".resource-listing li").show();    

            }
        }
    },

    niche: {

        init: function() {
            "use strict";

            SITE.UI.nav.stickyNavOn = false;
            
            /*SITE.Pages.niche.heroHeightAdjust();
            $(window).resize(function() {
                SITE.Pages.niche.heroHeightAdjust();
            });*/
        },

        heroHeightAdjust: function() {
            "use strict";

            var b = $("body");

            switch (SITE.UI.viewport.mode) {

                case 'sm':
                case 'md':
                case 'lg':
                case 'xl':
                    if (SITE.UI.viewport.height < 830
                        && SITE.UI.viewport.height > 600) {
                        b.css('paddingTop', SITE.UI.viewport.height - 20);
                    }
            }

        }
    },

    /**
     * Standalone Landing Page
     * -----------------------
     * @type {Object}
     */
    standalone: {

        init: function() {
            "use strict";

            // Set GTM Event
            dataLayer.push({'event': 'standalonePageLoaded'});

            if (typeof SG_WEBINAR_ID !== 'undefined' && typeof SG_WEBINAR_NAME !== 'undefined') {
                dataLayer.push({'event': 'webinarLandingPageLoaded'});
            }
        }
    },

    /**
     * Epic Resource Page
     * ------------------
     * @type {Object}
     */
    epicres: {

        init: function() {
            "use strict";

            // Set GTM Event
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({'event': 'epicResPageLoaded'});
            }

            // Internal Link Scrolling
            SITE.UI.internalLinks();

            $('#toc').on('inview', function(event, isInView) {
                
                if (isInView) {
                    
                    $("body").removeClass("hover-toc");
                    $("#hoverTocNav").hide();
                    $("#hoverToc").removeClass("cl");

                } else $("body").addClass("hover-toc");

            });

            $("#hoverToc").click(function() {
                $(this).toggleClass("cl");
               $("#hoverTocNav").slideToggle(200);
            });


        }
    },

    thankyou: {

        init: function() {
            "use strict";


            SITE.Pages.thankyou.valign();
            $(window).resize(function() {
                SITE.Pages.thankyou.valign();
            });

        },

        valign: function() {
            "use strict";

            var p       = $("#strategySession"),
                vidEl   = p.find('.stratses__vid'),
                vidElH  = vidEl.height(),
                el      = p.find('.stratses__signup'),
                mTop    = 0;

            switch(SITE.UI.viewport.mode) {

                case 'lg':
                case 'xl':
                    el.css('min-height', vidElH + 'px');
                    mTop = ( vidElH - el.children().eq(0).height() )/2;
                    el.css('padding-top', mTop + 'px');
                    break;

            }
        }
    }

};